<template>
  <div class="empty" :style="{ width: w, height: h }">
    <img :src="icons[iconType]" :style="{ width: width + 'px', height: height + 'px', marginBottom: marginBottom + 'px' }" />
    <div :style="{ color: color }">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'ELEmpty',
  props: {
    width: {
      type: [String, Number],
      default: 98,
    },
    height: {
      type: [String, Number],
      default: 98,
    },
    w: {
      type: String,
      default: 'auto',
    },
    h: {
      type: String,
      default: 'auto',
    },
    text: {
      type: String,
      default: '暂无内容',
    },
    iconType: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      default: '#cce6ff',
    },
    marginBottom: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        1: require('@/assets/image/empty.png'),
        2: require('@/assets/image/empty_2.png'),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 20px auto;
  font-size: 14px;
}
</style>
